( function () {
    'use strict';
    e.bootstrap = e.bootstrap || {};
    e.bootstrap.init = function () {
        e.bootstrap.form.init();
        e.bootstrap.carousel.init();
        e.bootstrap.affix.init();
        e.bootstrap.modal.init();
        e.bootstrap.dropdown.init();
        e.bootstrap.tabs.onFocusThisBlur();
    };
}() );
